import { Star } from "lucide-react";
import { useReveal } from "../../lib/animations";

const testimonials = [
  {
    name: "Marie V.",
    location: "Gent",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    quote:
      "Ik had een offerte voor dakisolatie van €8.400. OfferteExpert toonde aan dat ik €2.100 te veel betaalde. Na onderhandeling kreeg ik de werken voor €6.200 gedaan. De €4,99 verdiende ik duizendvoudig terug.",
  },
  {
    name: "Pieter D.",
    location: "Antwerpen",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    quote:
      "Als aannemer gebruik ik OfferteExpert zelf om mijn eigen offertes te benchmarken. Zo weet ik dat mijn prijzen eerlijk zijn en kan ik klanten dit ook bewijzen.",
  },
  {
    name: "Nathalie K.",
    location: "Brugge",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    quote:
      "Eenvoudig, snel en verrassend nauwkeurig. De onderhandelingstips alleen al waren de prijs meer dan waard. Aanrader voor iedereen die verbouwt.",
  },
];

export default function Testimonials() {
  const ref = useReveal();
  return (
    <section data-testid="testimonials" className="oc-section bg-oc-bg">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-3xl">
          <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            Stemmen uit de praktijk
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            Wat gebruikers zeggen
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="bg-white rounded-oc border border-oc-border p-9 transition-all hover:-translate-y-1 hover:shadow-oc-card-hover"
              style={{ animation: `fade-in-up 600ms ease-out both ${i * 100}ms` }}
            >
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <blockquote className="mt-5 text-oc-textPrimary text-[16px] leading-[1.7]">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-oc-border" />
                <div>
                  <p className="font-display font-semibold text-oc-primary text-[15px]">{t.name}</p>
                  <p className="text-oc-textSecondary text-[13px]">{t.location}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
